module.exports = __webpack_public_path__ + "img/icon__book-open.7cf13956.svg";